import type { FlowScreenConfig } from "@/shared/constants/flowTypes";
import { createModuleComplete } from "@/pages/postloss/modules/components/ModuleComplete";
import { createReviewParsedItems } from "@/pages/postloss/modules/components/ReviewParsedItems";
import { AddAccounts } from "../components/AddAccounts";
import { ManualAccountEntry } from "../components/ManualAccountEntry";
import { ReviewAccounts } from "../components/ReviewAccounts";

const FINANCIAL_CATEGORIES = [
  "Bank accounts",
  "Brokerage accounts",
  "Tax-advantaged savings",
  "Retirement accounts",
  "Crypto accounts",
  "NFTs",
  "Other digital assets",
];

export function createAccountBalancesScreens(): FlowScreenConfig[] {
  return [
    {
      id: "review_parsed_financial",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      hideButton: true,
      skipOnBack: true,
      customComponent: createReviewParsedItems({
        categories: FINANCIAL_CATEGORIES,
        sectionLabel: "accounts",
      }),
    },
    {
      id: "connect_accounts",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      hideButton: true,
      customComponent: AddAccounts,
    },
    {
      id: "manual_entry",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      title: "Tell us about this account",
      subtitle: "Share what you have. You can always come back to add or edit more.",
      hideButton: true,
      skipOnBack: true,
      customComponent: ManualAccountEntry,
    },
    {
      id: "review_accounts",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      title: "Here's what we have",
      subtitle:
        "Review the accounts below. Edit details, remove anything incorrect, or add accounts we missed.",
      hideButton: false,
      customComponent: ReviewAccounts,
      getButtonText: () => "Looks good",
      note: {
        content: "You can always return to this page and connect more accounts.",
        position: "below",
      },
    },
    {
      id: "financial_accounts_complete",
      layout: "full",
      textAlign: "center",
      hideButton: true,
      headerTitle: "",
      customComponent: createModuleComplete(),
    },
  ];
}
